import React from 'react';
import styles from './Contact.module.css';
import ContactForm from './ContactForm';
import Address from './Address';
import SocialMedia from './SocialMedia';

const Contact = () => {
  return (
    <div className={`${styles.contactDiv} containerWrapperRight`}>
      <h1>Contact</h1>
      <div className={styles.contact}>
        <Address />
        <ContactForm />
      </div>
      <SocialMedia />
    </div>
  );
};

export default Contact;
